


import React from "react";

export const CrownIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-4 h-4 text-brand",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} {...props}>
            <path d="M11.1335 12.6532H4.8668C4.5868 12.6532 4.27347 12.4332 4.18013 12.1666L1.42013 4.44658C1.0268 3.33991 1.4868 2.99991 2.43347 3.67991L5.03347 5.53991C5.4668 5.83991 5.96013 5.68658 6.1468 5.19991L7.32013 2.07324C7.69347 1.07324 8.31347 1.07324 8.6868 2.07324L9.86013 5.19991C10.0468 5.68658 10.5401 5.83991 10.9668 5.53991L13.4068 3.79991C14.4468 3.05324 14.9468 3.43324 14.5201 4.63991L11.8268 12.1799C11.7268 12.4332 11.4135 12.6532 11.1335 12.6532Z" fill="white" />
            <path d="M4.3335 14.667H11.6668" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.3335 9.33301H9.66683" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};